import Map from "./components/MapComponent"
import MapExpanded from "./components/MapExpanded"

import "./style.scss"

const MapDisplay = ({ postalCode, address }: $TSMigrationFixMe) => {
  return (
    <div className='map_display mt-2 w-100'>
      <Map
        postalCode={postalCode}
        address={address}
        className='map_display__normal'
      />
      <MapExpanded
        postalCode={postalCode}
        address={address}
      />
    </div>
  )
}

export default MapDisplay
